module.exports = __webpack_public_path__ + "assets/img/Enginio_logotype_stacked_neg.d82b525c.png";